/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProposalsNotifications_viewer$ref: FragmentReference;
declare export opaque type ProposalsNotifications_viewer$fragmentType: ProposalsNotifications_viewer$ref;
export type ProposalsNotifications_viewer = {|
  +proposalsForResponse: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +__typename: string
      |}
    |}>
  |},
  +$refType: ProposalsNotifications_viewer$ref,
|};
export type ProposalsNotifications_viewer$data = ProposalsNotifications_viewer;
export type ProposalsNotifications_viewer$key = {
  +$data?: ProposalsNotifications_viewer$data,
  +$fragmentRefs: ProposalsNotifications_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalsNotifications_viewer",
  "selections": [
    {
      "alias": "proposalsForResponse",
      "args": [
        {
          "kind": "Literal",
          "name": "reviewStatus",
          "value": "TO_REVIEW"
        }
      ],
      "concreteType": "ProposalConnection",
      "kind": "LinkedField",
      "name": "proposals",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProposalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Proposal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "proposals(reviewStatus:\"TO_REVIEW\")"
    }
  ],
  "type": "Person",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'fbd2ea0633405bf3373efb15b58603df';

module.exports = node;
